import { store } from '../store/store';
import { HttpRequest } from '../utils';

const httpRequest = new HttpRequest(store);

export const list = async (data: { page: number; limit: number; query?: string }) => {
  const res = await httpRequest.get('/api/role', data);
  return res;
};

export const create = async (data: any) => {
  const res = await httpRequest.post('/api/role', data);
  return res;
};

export const get = async (id: string) => {
  const res = await httpRequest.get(`/api/role/${id}/detail`);
  return res;
};

export const remove = async (id: string) => {
  const res = await httpRequest.del(`/api/role/${id}`);
  return res;
};

export const update = async (id: string, payload: any) => {
  const res = await httpRequest.put(`/api/role/${id}/update`, payload);
  return res;
};

export const changeStatus = async (id: string, status: 'ACTIVE' | 'INACTIVE') => {
  const res = await httpRequest.put(`/api/role/${id}/status`, {
    status: status,
  });
  return res;
};

export const select = async (payload: any) => {
  const res = await httpRequest.get(`/api/role/select`, {
    limit: 10000,
  });
  return res;
};
